  export const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
      if (title) {
        document.title = title;
      } else {
        document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
      }

      Object.keys(metaTags).forEach((metaName) => {
        if (metaName === 'cronical_url') return;
        const metaTag = document.querySelector(`meta[name="${metaName}"]`);
        if (metaTag) {
          metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
        } else {
          const newMetaTag = document.createElement('meta');
          newMetaTag.name = metaName;
          newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
          document.head.appendChild(newMetaTag);
        }
      });

      if (metaTags.cronical_url) {
        let canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute('href', metaTags.cronical_url);
        } else {
          canonicalLink = document.createElement('link');
          canonicalLink.setAttribute('rel', 'canonical');
          canonicalLink.setAttribute('href', metaTags.cronical_url);
          document.head.appendChild(canonicalLink);
        }
      }

      return () => {
        document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        Object.keys(metaTags).forEach((metaName) => {
          if (metaName === 'cronical_url') return;
          const metaTag = document.querySelector(`meta[name="${metaName}"]`);
          if (metaTag) {
            metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
          }
        });

        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute('href', window.location.href);
        }
      };
    } catch (error) {
      // Error handling
    }
  };
